<template>
  <div class="home">
    <div class="online_course_header_container">
      <div class="online_course_header_wrapper container">
        <div class="online_course_header_text">
          <div class="header_text_2"><strong>Terms of Use and Privacy Policy</strong></div>
          <div class="header_text_3" style="max-width: 100%;">
              <p>The objective of Sajilo Class is to enhance people's lives through education. We make it possible for anybody, everywhere, to create and share educational information, as well as to learn from it. We believe that our learning methodology is the most effective way to provide our users with useful instructional content. All of your activities on the Sajilo Class website, mobile applications, APIs, and other connected services ("Services") are governed by these Terms.</p>
              <ol class="online_course--list">
                <li>We acquire data directly from you, such as information you enter personally, data on your content consumption, and data from third-party platforms with which your account connects. We also gather information about your device and which areas of our Services you interact with or spend time with automatically.</li>
                <li>You may get permission from us to access the course just through our website/app/service and for no other purpose. In no circumstances are you permitted to transmit, distribute, or resell content if found guilty legal actions will be taken.</li>
                <li>Refunds, Credits, and Payments - You agree to use a legal payment method when you make a payment. The rates of Sajilo class material are set by the terms of Sajilo Class management and regulated by the guidelines of Sajilo Class administration. <br> Due to mobile platform providers' pricing structures and restrictions regarding implementing sales and promotions, the price of content supplied on the Sajilo Class website may not always be the same as the price offered on our mobile device. We conduct promotions and special offers for our content on occasion, during which selected content is accessible at a reduced price for a limited time. The price that applies to the content will be the price at the moment that you finish your content purchase. </li>
                <li>You fully accept the risks of using our services and agree that even if you incur damage or harm as a result of using our platform and Services, you will have no right to claim.</li>
                <li>Our platform may be unavailable due to scheduled maintenance or a technical problem. It's possible that one of our lecturers will make an error in their presentation. It's also possible that we'll encounter problems with cybersecurity. At any time and for any reason, we may decide to stop providing some features of the Services. Sajilo Class, its partners, suppliers, or agents shall not be liable for any damages resulting from such interruption or lack of availability of such functionalities under any circumstances. <br> We are not responsible for any delay or failure in our provision of Services caused by factors beyond our reasonable control, such as acts of war, terrorism, sabotage, natural disasters, etc.</li>
                <li>Updating the terms <br>We may update these Terms from time to time to explain the new or different practices (for example, when we introduce new features), Sajilo Class maintains the right to alter and/or change these Terms at any time in its sole discretion. If we make a significant change, we will tell you by prominent methods, such as an email notification sent to the email address indicated in your account or a notice posted on our Services. Unless otherwise specified, all changes will take effect the day they are posted. <br>You agree to the changes if you continue to use our Services after they take effect. Any new Terms will take precedence over any existing Terms.</li>
              </ol>
              <br>
              <p>By visiting the Sajilo Class website or app you are accepting our terms of service and disclaimer notice.</p>
          </div>
        </div>
      </div>
    </div>
    <div class="online_course_main">
      <div class="online_course_main_wrapper">

        <KeepLearning></KeepLearning>
      </div>
    </div>
  </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import CourseCard from '@/components/Courses/CourseCard.vue'
import lecturer from '@/components/Courses/Lecturer.vue'
import KeepLearning from '@/components/KeepLearning/KeepLearning.vue'
// import {mapGetters} from 'vuex'
export default {
  name:'About',
  data () {
    return {
      settings: {
        dots: true,
        arrows: false,
        focusOnSelect: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        touchThreshold: 5,
        autoplay: true,
        fade: true,
        cssEase: 'linear',
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              dots: true
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              initialSlide: 1
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      },
      courses: {
      },
      teacher: [
        {
          first_name: 'John',
          last_name: 'Doe',
          email: 'test@rest.com'
        },
        {
          first_name: 'John',
          last_name: 'Doe',
          email: 'test@rest.com'
        },
        {
          first_name: 'John',
          last_name: 'Doe',
          email: 'test@rest.com'
        },
        {
          first_name: 'John',
          last_name: 'Doe',
          email: 'test@rest.com'
        },
        {
          first_name: 'John',
          last_name: 'Doe',
          email: 'test@rest.com'
        },
      ],
      teacherlist: null,
    }
  },
  components: { 
    VueSlickCarousel,
    CourseCard,
    lecturer,
    KeepLearning
  },
  filters: {
      truncate: function (text, length, suffix) {
          if (text.length > length) {
              return text.substring(0, length) + suffix;
          } else {
              return text;
          }
      },
  },
  
  created () { 
      this.$store.dispatch('getFeatureCourses').then(res => {
        this.$bus.emit('loading-toggle')
        let courselist = res.results;
        for(let i =0; i <= 5; i++) {
          if(courselist[i]) {
            this.getCourses(courselist);
          }
        }
      })
  },

  mounted () {
    this.getLecture();
  },

  methods: {
    getCourses(course) {
      this.courses = course;
      this.$bus.emit('loading-toggle')
    },
    async getLecture() {
      await this.$api.get(`authuser/lecturer-list/`).then(res => {
        this.teacherlist = res.results;
      })
    },
    feature() {
      window.location.reload();
        window.scrollTo(0,0);
    }
  },

  // computed: {
  //   ...mapGetters({
  //     getLecturer: 'lecturer',
  //   }),
  // },
  
}
</script>

<style>
/* Header part */
.online_course_header_wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5rem 0;
}
.online_course_header_text {
  padding: 0 36px;
  margin-top: 20px;
}
.header_text_2 {
  font-size: 48px;
  margin-bottom: 12px;
  line-height: 1.2;
  font-weight: 400;
}
.header_text_2 strong {
  color: var(--color-red);
}
.header_text_3 {
  font-size: 20px;
  max-width: 550px;
  font-family: var(--font-poppins);
  color: var(--color-dark);
}
.button_wrapper {
  margin-top: 25px;
  font-family: var(--font-poppins);
}
.online_course_header_image {
  width: 100%;
  height: 447px;
}

.header_image_container {
  position: relative;
  height: 100%;
}
.header-group-1 {
  position: absolute;
  top: 0;
  right: 12%;
  z-index: 1;
}
.header-main-image {
  position: absolute;
  left: 18.5%;
  bottom: 0;
  height: 385px;
  width: 465px;
  z-index: 2;
}
.header-main-image img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}
.header-group-2 {
  position: absolute;
  bottom: -11%;
  left: 8%;
  z-index: 3;
}
.header-group-2 > * {
  font-size: 5.625rem;
  color: var(--color-primary);
}
@media (min-width: 1904px) {
  .online_course_header_wrapper {
    max-width: 1785px;
    margin: auto;
  }
}
@media (max-width: 768px) {
  .online_course_header_image {
    display: none;
  }
  .header_text_2 {
    font-size: 36px;
  }
}

/* Why student trust */
.online_course_main {
  padding-top: 8rem;
}
.student_trust_container {
  background-color: rgb(14,161,223,0.03);
}
.student_trust_wrapper {
  padding: 4.5rem 0;
}
.student_trust_content_container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 36px;
  font-family: "Lora", serif;
}
.student_trust_text {
  max-width: 600px;
}
.student_trust_title {
  font-size: 36px;
  font-weight: 600;
  color: #4f4e4e;
}
.student_trust_heading {
  text-align: center;
  font-size: 36px;
  font-weight: 400;
  font-family: var(--font-poppins);
  margin-bottom: 98px;
}
.student_trust_heading span {
  color: var(--color-red);
  font-family: var(--font-lora);
  font-weight: 700;
}
.trust_orange_button {
  background: #efefef;
  border-radius: 3px;
}
.trust_orange_button i {
  background: var(--color-pink);
  color: #fff !important;
  padding: 5px;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
}
.trust_purple_button {
  background: #efefef;
  border-radius: 3px;
}
.trust_purple_button i {
  background: var(--color-primary);
  color: #fff !important;
  padding: 5px;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
}
.trust_orange_button span, .trust_purple_button span{
  padding: 0 16px;
  font-size: 14px;
  color: #181818;
}
.trust_content {
  padding-top: 4rem;
}
.student_trust_content_left {
  width: 100%;
}
.student_trust_image {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 50px;
}
.student_trust_content_right {
  width: 100%;
}
.content_left_first, .content_left_third {
  text-align: right;
}
.content_left_second {
  text-align: center;
}
.content_right_second {
  text-align: center;
}
.student_trust_image img {
  width: 230px;
  height: 100%;
}
.content_middle {
  text-align: center;
}
@media screen and (max-width: 768px) {
  .student_trust_image {
    display: none;
  }
  .student_trust_text {
    text-align: center;
  }
  .student_trust_title {
    font-size: 28px;
  }
}

/*Featured Courses */
.fatured_courses .container {
  padding-top: 0;
  padding-bottom: 0;
}
.featured_courses_wrapper {
  padding: 5.6rem 0;
}
.featured_courses_card {
  /* background: #efefef !important; */
}


/* Explore course*/
.explore_courses_wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}
.explore_courses_card:not(:last-child) {
  padding-right: 16px;
}
.explore_courses_heading {
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-size: 24px;
  padding-bottom: 20px;
  font-family: "Lora", serif;
}
.android_img {
  padding: 0 16px;
  margin-bottom: 16px;
}
.android_img img {
  background-color: #fff;
  border: 3px solid var(--color-primary);
  padding: 5px 10px;
  border-radius: 10px;
  margin-top: -30px;
  z-index: 999;
  position: absolute;
}
.courses_price_wrapper {
  position: relative;
}
.courses_price_wrapper > * {
  background-color: var(--color-red);
  color: var(--color-white);
  font-weight: 700;
  border: none;
  width: 90px;
  height: 90px;
  text-align: center;
  font-size: 24px;
  line-height: 1.4;
  padding-top: 5px;
  /* padding: 5px 10px; */
  border-radius: 100%;
  z-index: 999;
  position: absolute;
  margin-top: -10%;
  right: 18px;
  font-family: var(--font-lora);
}
.v-card {
  font-family: var(--font-poppins);
}
.card-meta-info {
  padding: 10px 16px;
  line-height: 1.5;
  color: var(--color-dark);
}
.card-meta-info .date {
  font-size: 12px;
  margin-bottom: 6px;
}
.card-meta-info .instructor-name {
  font-size: 14px;
  margin-bottom: 8px;
}
.card-meta-info + .v-card__title {
  padding: 0 16px;
  margin-bottom: 15px;
}
.card-purchase-count {
  padding: 0 16px;
  font-size: 14px;
  font-weight: 400;
}
.best_selling_btn {
  padding: 0 16px;
}
.card_info_rating {
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #807c7c;
}
.card-actions {
  padding: 16px;
}
.view_course_btn {
  padding: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.explore_online_courses {
  border-bottom: 2px solid #efefef;
}
@media screen and (max-width: 768px) {
  .explore_courses_wrapper {
    flex-direction: column;
  }
  .explore_courses_card:not(:last-child) {
    padding-bottom: 2rem;
    padding-right: 0;
  }
}

/* What students say */
.students_say_heading {
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-size: 24px;
  padding: 20px;
  font-family: "Lora", serif;
}
.students_say {
  padding-bottom: 3rem;
}
.student_img {
  display: flex;
  justify-content: center;
  align-items: center;
}
.student_img img {
  border-radius: 50%;
  height: 150px;
  width: 150px;
}
.students_say_slider .slick-list .slick-track .slick-slide {
  padding: 1rem;
}
.students_say_slider .slick-prev:before,
.slick-next:before {
  color: #222 !important;
}
.stds_say_title {
  justify-content: center;
}
.stds_say_subtitle {
  text-align: center;
}
.students_say_card {
  padding: 1rem;
}
@media screen and (max-width: 768px) {
  .students_say_slider .slick-list {
    text-align: center;
  }
  .students_say_slider .slick-list .slick-track .slick-slide {
    padding: 0.5rem;
  }
  .slick-prev {
    left: 0;
  }
  .slick-next {
    right: 0;
  }
}

/* Goals Part */
.goals_container {
  background-color: #fcf4cf;
}
.goals_content_container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 36px;
}
.goals_text {
  max-width: 450px;
}
.goals_title {
  font-size: 24px;
  font-family: "Lora", serif;
}
.goals_content {
  padding: 1rem 0;
  font-family: "Lora", serif;
}
@media screen and (max-width: 768px) {
  .goals_image {
    display: none;
  }
}

/* Learning Statistics Part */
.learning_statistics_content_container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.learning_statistics_text {
  max-width: 450px;
}
.learning_statistics_content {
  padding: 1rem 0;
  font-size: 24px;
  font-family: "Lora", serif;
}
.learning_statistics_image {
  position: relative;
}
.learning_statistics_image_text {
  position: absolute;
  max-width: 350px;
  top: 35%;
  left: 0%;
  padding: 1rem 3rem;
  font-size: 24px;
  color: #3473ef;
  background: #ffffffeb !important;
  font-family: "Lora", serif;
}
@media screen and (max-width: 768px) {
  .learning_statistics_content_container {
    flex-direction: column;
  }
  .learning_statistics_text {
    text-align: center;
  }
}
</style>
